 <template>
  <div class="col col-lg-6">
    <div>
      <label for="subGrupoField">
        Subgrupo
        <span class="recent-updated-label" v-if="recentUpdatedField">
          <tooltip-informacao-alterada />
        </span>
        <select
          :disabled="disabled"
          id="subGrupoField"
          v-model="model.content"
          class="form-select"
          :class="{
            'is-invalid-yellow': $v.model.content.$error && invalidYellow,
            'recent-updated': recentUpdatedField,
          }"
        >
          <option
            v-for="(subGrupo, subGrupoIndex) in list"
            :key="`uf_option_${subGrupoIndex}`"
            :value="subGrupo.subGrupo"
          >
            {{ subGrupo.subGrupo }}
          </option>
        </select>
      </label>
      <div
        v-if="loading"
        style="margin-left: -50px"
        class="spinner-border spinner-border-sm"
      ></div>
    </div>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import FieldTemplate from "@/components/forms/fields/empresa/FieldTemplate.vue";
import TooltipInformacaoAlterada from "@/components/forms/TooltipInformacaoAlterada.vue";
export default {
  extends: FieldTemplate,
  props: {
    list: Array,
    loading: Boolean,
    disabled: Boolean,
    modelProp: Object,
    invalidYellow: Boolean,
    recentUpdatedField: Boolean,
  },
  data() {
    return {
      model: {
        name: "subGrupo",
        content: "",
      },
    };
  },
  validations: {
    model: {
      content: {
        required: requiredIf(function () {
          if (this.invalidYellow) {
            return true;
          }
          return false;
        }),
      },
    },
  },
  components: {
    TooltipInformacaoAlterada,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/style.scss";
label {
  width: 100% !important;
}

.align-spinner {
  display: flex;
  align-items: center;
}
</style>
